import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { IToolUserParamsApiListResponse, IToolUserParamUpdateParams, IToolUserParamUpdateResponse } from '@/types/toolUserParams';

export const toolUserParamsList = (toolUserId: number, config?: AxiosRequestConfig): Promise<AxiosResponse<IToolUserParamsApiListResponse>> => {
    return axios.get('/api/toolUserParams/list', {
        ...config,
        params: { toolUserParamsToolUserId: toolUserId },
    });
};

export const toolUserParamsCreate = (params: IToolUserParamUpdateParams): Promise<AxiosResponse<IToolUserParamUpdateResponse>> => {
    return axios.post('/api/toolUserParams/create', params);
};

export const toolUserParamsUpdate = (params: IToolUserParamUpdateParams): Promise<AxiosResponse<IToolUserParamUpdateResponse>> => {
    return axios.post('/api/toolUserParams/update', params);
};

export const toolUserParamsDelete = (params: IToolUserParamUpdateParams): Promise<AxiosResponse<IToolUserParamUpdateResponse>> => {
    return axios.post('/api/toolUserParams/delete', params);
};
